/**
 * Help & Assistance Feature - Main Export
 */

import HelpModal from './components/HelpModal';
import AssistanceDock from './components/AssistanceDock';
import { helpService } from './services/helpService';
import { atlasService } from './services/atlasService';

export const initHelpAssistanceServices = async () => {
  await helpService.init();
  console.log('Help & Assistance services initialized');
};

export const helpAssistance = {
  // Services
  service: helpService,
  helpService: helpService, // Alias for convenience
  atlasService: atlasService,

  // Help UI Components
  HelpModal,
  AssistanceDock,

  // Show help for a specific context
  showHelp(context = 'general') {
    helpService.openHelp(context);
  },

  // Start an interactive tutorial
  startTutorial(tutorialId) {
    console.log(`Starting tutorial: ${tutorialId}`);
  },

  // Search through available guides
  searchHelp(query) {
    return helpService.search(query);
  }
};

export { HelpModal, AssistanceDock };
export { helpService };
export default helpAssistance;